import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: auto;
    height: auto;
    padding: 5px 8px;

    gap: 4px; 
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 10rem;
    background-color: ${props =>
    // Todos os outros estados (Status)
    props.status === 0 ? theme.colors.red.fundo :
    props.status === 1 ? theme.colors.green.fundo :
    props.status === 2 ? theme.colors.yellow.fundo :
    props.status === 3 ? theme.colors.orange.fundo :
    props.status === 4 ? theme.colors.red.fundo :
    theme.colors.green.fundo
    };

    cursor: ${props => props.status === 0 ? 'context-menu' : 'pointer'};

    >span{
        white-space: nowrap;
    }
`;

export const ContainerStatus = styled.div`
    width: auto;
    height: auto;

    >img {
        width: 12px;
        height: auto;
    }

    >img.spinning {
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }
`;